import { createAction, props } from '@ngrx/store';
import { FlowTableRow } from '../models/flows.model';

export const OpenSidenav = createAction('[Flows: Side Nav]: Sidenav Opened');

export const CloseSidenav = createAction('[Flows: Side Nav]: Sidenav Closed');

export const ViewFlow = createAction('[Flows: Side Nav]: View Flow', props<{ flow: FlowTableRow }>());

export const EditFlow = createAction(
  '[Flows: Side Nav]: Edit Flow',
  props<{ flow: FlowTableRow; isAdvanced?: boolean }>(),
);

export const EditMode = createAction('[Flows: Side Nav]: Edit Mode');

export const EditModeAdvanced = createAction('[Flows: Side Nav]: Edit Mode Advanced');
